import { useMutation } from '@apollo/client'
import { useAppDispatch } from '_store'
import classnames from "classnames";
import { AuthContext } from 'AuthContext'
import { EledoFormGenerator, EledoPageHeader, EledoPendingContent } from 'components/library'
import { useShowMenu } from 'hooks'
import { PlatformContext } from 'PlatformContext'
import React, { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import styles from 'components/library/EledoPageHeader.module.scss';
import { LinkPasswordFormModel, LoginPasswordFormModel } from 'model/login';
import { AuthenticateDataData, AuthenticateVars, GET_AUTHENTICATE } from 'graphql/AuthQueries';
import { setAllRequests } from '_reducers/puzzleRequests';
import { Tracker, TrackerUser } from 'Tracker';

type LoginPasswordFormData = {
  password: string
  rememberMe: boolean
}

type LocationState = {
  token: string
  userId: string
  email: string
  from: {
    pathname: string
    search: string
  }
}

const EledoLinkAccount = () => {
  const auth = useContext(AuthContext);
  const platform = useContext(PlatformContext);
  const navigate = useNavigate()
  const state = useLocation().state as LocationState;
  const email = state?.email
// console.log("state", state)
  const dispatch = useAppDispatch();
  const [doAuth, { loading, error }] = useMutation<AuthenticateDataData, AuthenticateVars>(GET_AUTHENTICATE, {
    onCompleted(data, clientOptions) {
      if(data){
        
//        console.log(data)
        
        if(data){

          const trackerUser: TrackerUser = {
            id: data.authenticate.user?.id || null,
            level: data.authenticate.level
          }
      
          Tracker.event("action.link.user", trackerUser, {})

          if((data.authenticate.accounts?.length || 0) > 0){
            return navigate("/login/accountSelect", { state: { ...state, ...clientOptions?.variables, accounts: data.authenticate.accounts }})
          }
          const authVars = clientOptions?.variables as AuthenticateVars
          
          auth.login(data.authenticate, authVars.type);
          
          if(data.authenticate.requests){
            dispatch(setAllRequests(data.authenticate.requests));
          }
// console.log(state.from)
          if(data.authenticate.user != null){
            if(state?.from?.pathname){
              navigate(state.from.pathname + state.from.search);
            }else{
              navigate("/templates/mine");
            }
          }
        }
      }
    },
    onError(error){
    }
  });
  
  // useEffect(() => {
  //   if(auth.user != null){
  //     if(state?.from?.pathname){
  //       navigate(state.from.pathname + state.from.search);
  //     }else{
  //       navigate("/templates/mine");
  //     }
  //   }
  // }, [platform, auth, navigate, state?.from?.pathname, state?.from?.search]);

  const formHandler = useForm<LoginPasswordFormData>({mode: "onChange"});
  const { formState: {isValid, isSubmitted} } = formHandler;

  useShowMenu();

  const onSubmitHandler = (data: LoginPasswordFormData) => {
    if(isValid) {
      platform.authService.provideAuthData()
        .then(provided => {
          
          const authenticate: AuthenticateVars = {
            type: "sso",
            payload: state.token,
            mergeUserId: state.userId,
            mergePassword: data.password,
            rememberMe: data.rememberMe
          }
//          console.log("authenticate", authenticate)
          doAuth({ variables: authenticate });
        })
    }
  }

  if(!auth.canLetLogin){
    return (
      <Navigate to={{pathname: '/start'}}/>
    )
  }

  return (
    <div>
      <EledoPageHeader/>

      <div className={classnames(styles.EledoLogin, "container")} data-testid="EledoLogin">
        <div className="section section-small">
          <div className="hero-paragraph text-center">
            <h2><b>Link To Your Eledo Account</b></h2>
            <p>We found an existing Eledo account associated with your email. Would you like to link your account?</p>
          </div>
          <FormProvider {...formHandler}>
            <form onSubmit={formHandler.handleSubmit(onSubmitHandler)}>
              <div style={{width: "20rem"}} className="center">
                <EledoFormGenerator formModel={LinkPasswordFormModel}
                                    editedDataObject={{}}/>

                <p style={{lineHeight: "100%", textAlign: "right"}}>
                  <a href="https://eledo.online/recovery" target="_blank" rel="noreferrer">Forgot your password?</a>
                </p>
                {error !== undefined && <span className="center text-center" style={{display: "block"}}>
                  <small className="error-message" style={{float: "initial"}}>{error.message}</small>
                </span>}

                <div className="hero-paragraph text-center">
                  <span data-tip={isSubmitted || isValid || loading ? "" : "Please check your credentials before logging in"}
                        data-for={isSubmitted || isValid || loading ? "" : 'login-button-tooltip'}>
                    <button className={"button"} type="submit"
                          {...(isValid ? {} : {"aria-disabled": "true"})}>
                      <EledoPendingContent state={loading}
                                          content="Link and Log In"
                                          pendingContent="Linking and Logging in..."/>
                    </button>
                  <ReactTooltip
                    id="login-button-tooltip"
                    place="right"
                    type="warning"
                    effect="float"
                    multiline={true}
                  />
                  </span>
                </div>


              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  )
}

export default EledoLinkAccount